<template>
<div style="position: absolute; right: 0px; top: -50px; z-index: 10">
    <v-menu v-model="menuWidget" :close-on-content-click="false" :nudge-width="400" location="start">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on"><v-icon medium>fa-tag</v-icon>{{ label }}<v-icon right dark>fa-caret-down</v-icon></v-btn>
        </template>
        <v-card>
            <v-list>
                <template v-for="item in allFlags" >
                    <v-list-item v-bind:key="item.ID">
                        <v-list-item-action>
                            <v-switch v-model="item.Checked" :color="item.FlagColor" @change="updateFlag(item)"></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>{{item.FlagName}}</v-list-item-title>
                        <v-list-item-avatar>
                            <v-icon medium :color="item.FlagColor">fa-tag</v-icon> 
                        </v-list-item-avatar>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>
    </v-menu>
</div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import _ from "lodash";
import { eventBus } from '@/main';
export default {
    name: 'order-flag-menu',
    props: {
        orderID: {
            type: Number,
            default: 0
        },
        orderIDs: {type: Array, default: () => []},
        orderType: {
            type: Number,
            default: 1
        },
        label: {
            type: String,
            default: 'Cập nhật tag'
        },
        action: {
            type: String,
            default: 'update'
        },
    },
    data() {
        return {
            menuWidget: false,
            currentItem: null
        }
    },
    watch: {
        menuWidget() {
            this.filter_data();
        }
    },
    methods: {
        filter_data() {
            if(this.action == 'filter' && this.allFlags.length > 0) {
                return;
            }
            if(this.orderIDs && this.orderIDs.length > 0) {
                this.$store.dispatch("orderFlag/getList", {'OrderIDs': this.orderIDs, 'OrderType': this.orderType});
            }
            else {
                this.$store.dispatch("orderFlag/getList", {'OrderID': this.orderID, 'OrderType': this.orderType});
            }
        },
        updateFlag: _.debounce(
            function(item) {
                if(this.action == 'filter') {
                    this.$emit("eventFilterChange", {
                        flag_ids: _.map(_.filter(this.allFlags, (p) => {return p.Checked}), 'FlagID')
                    });
                    return;
                }
                if(!this.orderID && (!this.orderIDs || !this.orderIDs.length)) {
                    Vue.notify({group: 'foo',type: 'error',title: 'Thông báo!',text: 'Không có đơn hàng nào được chọn!'});
                    return;
                }
                if(item.Checked) {
                    this.$store.dispatch("orderFlag/setDetail", {
                        data: {
                            OrderIDs: this.orderIDs,
                            OrderID: this.orderID,
                            OrderType: this.orderType,
                            FlagID: item.FlagID
                        },
                        id: 0
                    });
                    // this.menuWidget = false;
                }
                else if(!item.Checked && item.ID) {
                    this.$store.dispatch("orderFlag/removeDetail", {id: this.orderIDs.length == 0 ? item.ID : 999999999, data: {OrderIDs: this.orderIDs, FlagID: item.FlagID, OrderType: this.orderType}});
                    // this.menuWidget = false;
                }
            },
            300,
            {
                leading: true,
                trailing: false
            }
        )
    },
    computed: {
        allFlags() {
            return this.$store.state.orderFlag.all.data
        }
    },
    mounted() {
        eventBus.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        eventBus.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
}
</script>
